import {Box, Container} from '@mui/material';
import React, {Fragment} from 'react';

import {MainFooter, StyledGrid} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {FailureAlert} from 'presentation/pages/private/refund/components/FailureAlert';
import {translations} from 'presentation/translations-new';
import {useGetRefundModalitiesQuery} from '../../queries/useGetRefundModalitiesQuery';
import {ServiceCardsList} from './components/ServiceCardsList';
import {StyledContainer, StyledFooterContainer} from './styles';

type ServiceTypeProps = {
	handleNextStep: () => void;
};

const {loading} = translations['pt-br'].commons;

export const ServiceType = ({handleNextStep}: ServiceTypeProps) => {
	const {data, isLoading, isError, refetch} = useGetRefundModalitiesQuery();
	const {isMobile} = useMediaQueries();

	if (isError) {
		return (
			<StyledContainer>
				<FailureAlert refetch={refetch} />
			</StyledContainer>
		);
	}

	if (isLoading) {
		return (
			<Box m="auto">
				<Loading text={loading} />
			</Box>
		);
	}

	return (
		<Fragment>
			<Container>
				<StyledGrid.Root marginTop={isMobile ? 0 : 2} spacing={2}>
					<ServiceCardsList data={data} handleNextStep={handleNextStep} />
				</StyledGrid.Root>
			</Container>

			<StyledFooterContainer>
				<MainFooter />
			</StyledFooterContainer>
		</Fragment>
	);
};
